import React, {useEffect, useRef } from "react";
import './Navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const Navibar = () => {
    const navRef = useRef(null);

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 50) {
          navRef.current.classList.add('navbar-scrolled');
        } else {
          navRef.current.classList.remove('navbar-scrolled');
        }
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

	return (
        <nav ref={navRef} class="navbar navbar-expand-lg fixed-top" aria-label="Offcanvas navbar large">
        <div class="container-fluid">
        <a class="navbar-brand" href="/">R&N</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasNavbarDarkLabel"><a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>R&N</a></h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
            <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/about">About Us</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/venue">Venue</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/accommodation">Accommodation</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/registry">Registry</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/ootd">Order of the Day</a>
                    </li>
                    <li class="nav-item">
                    <a class="nav-link thicker" href="/faq">FAQs</a>
                    </li>
                    <li class="nav-item">
                    <a href="/rsvp" class="btn rsvp-button" role="button">RSVP</a>
                    </li>
            </ul>
            </div>
        </div>
        </div>
        </nav>
	);
};

export default Navibar;
